import * as React from "react"
import PatientNotesOOCCard, {IPatientNotesOOC} from "../../components/patient/PatientNotesOOCCard";
import * as _ from "lodash";
import * as moment from "moment";
import * as RoutesConfig from "../../routes";
import {ApiManager} from "../../api/ApiManager";
import AddPatientNotesOOCModal from "../../components/patient/AddPatientNotesOOCModal";
import IDoctorProfile from "../../models/IDoctorProfile";
import {IAppState} from "../../models/IAppState";
import {connect} from "react-redux";
import {Tracker} from "../../utils/Tracker";
import {EventNames} from "../../utils/EventTrackerConstants";
import {default as CTA, CTATheme} from "../../components/common/CallToAction";
import FileUploader from "../../components/common/FileUploader"

export interface PatientNotesOOCContainerProps {
    doctorProfile: IDoctorProfile
    params?: any
}

export interface PatientNotesOOCContainerState {
    patientNotesOOCList: IPatientNotesOOC[],
    showModal: boolean,
}

class PatientNotesOOCContainer extends React.Component<PatientNotesOOCContainerProps, PatientNotesOOCContainerState> {

    constructor(props: PatientNotesOOCContainerProps) {
        super(props);
        this.state = {
            patientNotesOOCList: [],
            showModal: false
        }
    };

    componentDidMount = () => {
        ApiManager.getEHRApis().getPatientNotesOOC(this.getPatientId()).then((patientNotesOOCList: IPatientNotesOOC[]) => {
            this.setState({patientNotesOOCList})
        })
        Tracker.track(EventNames.Patient_Notes, {doctorName: _.get(this.props, "doctorProfile.name", "")})
    }

    getPatientId = () => {
        return parseInt(this.props.params[RoutesConfig.PATIENT_ID_PARAM]);
    }

    openModal = () => {
        this.setState({
            showModal: true
        })
        Tracker.track(EventNames.Add_Patient, {doctorName: _.get(this.props, "doctorProfile.name", "")})
    }

    savePatientNotesOOC = (patientNotesOOC: IPatientNotesOOC) => {
        if (_.isEmpty(patientNotesOOC.notes)) return
        this.setState(state => {
            return {
                patientNotesOOCList: [...state.patientNotesOOCList, patientNotesOOC],
                showModal: false
            }
        })
        ApiManager.getEHRApis().savePatientNotesOOC(this.getPatientId(), patientNotesOOC)
    }

    onHide = () => {
        this.setState({
            showModal: false
        })
    }


    groupByDate = (data: any) => {
        const groups = data.reduce((groups: any, game: IPatientNotesOOC) => {
            let format = moment(game.recordedDate).format("Do, MMM");
            if (!groups[format]) {
                groups[format] = [];
            }
            groups[format].push(game);
            return groups;
        }, {});

        const groupArrays = Object.keys(groups).map((recordedDate) => {
            return {
                recordedDate,
                patientNotesOOCList: groups[recordedDate]
            };
        });
        return groupArrays.sort((a, b) => {
            return moment(b.recordedDate, "Do, MMM").valueOf() - moment(a.recordedDate, "Do, MMM").valueOf()
        })
    }


    render() {
        let list = this.groupByDate(this.state.patientNotesOOCList.filter((patientNotesOOC: IPatientNotesOOC) => {
            return patientNotesOOC.tenant === _.get(this.props, "doctorProfile.tenant", "")
        }))

        return (
            <div className={"patient-notes-ooc-container"}>
                {
                    <AddPatientNotesOOCModal
                        savePatientNotesOOC={this.savePatientNotesOOC}
                        show={this.state.showModal}
                        onHide={this.onHide}
                    />

                }
                {
                    <CTA innerText={"Add Note"} theme={CTATheme.PRIMARY} onClick={this.openModal} customStyle={{width: 120, marginLeft: "auto"}}/>
                }
                {
                    _.map(list, (group: { recordedDate: string, patientNotesOOCList: IPatientNotesOOC[] }, index: number) => {
                        let patientNotesOOCList = group.patientNotesOOCList.sort((a, b) => {
                            return moment(b.recordedDate).valueOf() - moment(a.recordedDate).valueOf()
                        })

                        return <div key={"patient-notes-ooc-card-list" + index}>
                            <p className={"patient-notes-ooc-recorded-date"}>{group.recordedDate}</p>
                            <br/>
                            <div className={"patient-notes-ooc-card-border-div"}>
                                {
                                    _.map(patientNotesOOCList, (patientNotesOOC: IPatientNotesOOC, index: number) => {
                                        return <PatientNotesOOCCard key={"patient-notes-ooc-card-" + index}
                                                                    patientNotesOOC={patientNotesOOC}/>
                                    })
                                }
                            </div>
                        </div>
                    })
                }
            </div>
        )
    }
}

const mapStateToProps = (state: IAppState): PatientNotesOOCContainerProps => {
    return {
       doctorProfile: state.doctorProfile
    }
}


export default connect(mapStateToProps, null )(PatientNotesOOCContainer)